import React from "react";
import SectionHeading from "./SectionHeading";

const SimpleLinedCard = ({ className, icon, title, content }) => {
    return (
        <div className={`flex flex-col items-center border-2 p-5 ${className}`}>
            {icon}
            <SectionHeading>{title}</SectionHeading>
            <p className="text-primaryText">{content}</p>
        </div>
    );
};

export default SimpleLinedCard;
